import _ from 'lodash';
import { connect as connectR } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../main/left-side';
import LargeCard from '../main/large-card';
import TitleCard from '../main/title-card';
import LocationBasicForm, {
    FIELD_BOOKING_LOGIC,
    FIELD_BOOKING_MINUTES,
    FIELD_GATEWAY_SERIALNUMBER,
} from './forms/location-basic-form';
import OrderPostit from './forms/order-postit';
import Postit from '../main/postit';
import LocationCostsForm from './forms/location-costs-form';
import LocationPositionForm, {
    DEFAULT_CENTER,
} from './forms/location-position-form';
import translate from '../translate';
import {
    BookingLogicPolicy,
    CreateLocation as CreateLocationCall,
    LoadLocationsForMansionId,
} from '../../store/locationsSlice';
import { LoadMansions } from '../../store/mansionsSlice';
import { goToMansion } from '../../nav/navigationService';
import withParams from '../../nav/withParams';

const defaultFields = {
    name: '',
    gps_lat: DEFAULT_CENTER.lat,
    gps_lon: DEFAULT_CENTER.lon,
    mansion_id: '',
    num_of_appartments: '',
    washer_cost: '',
    dryer_cost: '',
    reservation_minutes: 0,
    pickup_minutes: 0,
    note: '',
    currency_type: 'EUR',
    [FIELD_BOOKING_MINUTES]: 0,
    [FIELD_BOOKING_LOGIC]: BookingLogicPolicy.APPLIANCE_START,
};

class CreateLocation extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        params: PropTypes.shape({
            object_id: PropTypes.string,
        }).isRequired,
        LoadLocationsForMansionId: PropTypes.func.isRequired,
        CreateLocationCall: PropTypes.func.isRequired,
        LoadMansions: PropTypes.func.isRequired,
        mansionsById: PropTypes.shape({}).isRequired,
        GetCoordsForAddress: PropTypes.func.isRequired,
        mansionCoordsById: PropTypes.arrayOf(
            PropTypes.shape({ lat: PropTypes.number, lon: PropTypes.number })
        ).isRequired,
    };

    state = {
        location: _.extend({}, defaultFields),
        objectAddress: undefined,
        mansionId: undefined,
    };

    componentDidMount() {
        this.props.LoadLocationsForMansionId(
            Number(this.props.params.object_id)
        );
        this.props.LoadMansions();
    }

    componentWillReceiveProps(nextProps) {
        const mansionId = Number(nextProps.params.object_id);
        const mansion = nextProps.mansionsById[mansionId];
        if (mansion) {
            if (this.state.mansionId !== mansion.id) {
                this.setState({ mansionId: mansion.id });
            }
        }
    }

    getCards = (info, costs) => {
        const locationInfoCard = (
            <LargeCard
                type="card-edit"
                title={`${this.props.strings.create1} ${this.props.strings.create2}`}
            >
                <LocationBasicForm
                    handleChange={this._handleWholeForm}
                    mansionId={parseInt(this.props.params.object_id, 10)}
                    forceValidation={this.state.forceValidation}
                />
            </LargeCard>
        );
        const locationCostCard = (
            <LargeCard type="card-edit" title={this.props.strings.price}>
                <LocationCostsForm
                    handleChange={this._handleWholeForm}
                    forceValidation={this.state.forceValidation}
                />
            </LargeCard>
        );
        return { locationInfoCard, locationCostCard };
    };

    _isValid = () => {
        return (
            this.state.isLocationFormValid &&
            this.state.isLocationCostsFormValid
        );
    };

    _handleWholeForm = (component, submit) => {
        const stateLocation = this.state.location;
        if (component) {
            if (component.name) {
                const info = component;
                const location = _.extend(stateLocation, {
                    name: info.name,
                    num_of_appartments: info.num_of_appartments,
                    reservation_minutes: info.reservation_minutes,
                    [FIELD_BOOKING_MINUTES]: info[FIELD_BOOKING_MINUTES],
                    pickup_minutes: info.pickup_minutes,
                    [FIELD_BOOKING_LOGIC]: info[FIELD_BOOKING_LOGIC],
                    [FIELD_GATEWAY_SERIALNUMBER]:
                        info[FIELD_GATEWAY_SERIALNUMBER],
                });
                this.setState({
                    location: location,
                    isLocationFormValid: info._valid,
                });
            } else if (component.position) {
                const coordinates = component;
                const location = _.extend(stateLocation, {
                    gps_lat: coordinates.position.lat,
                    gps_lon: coordinates.position.lon,
                });
                this.setState({
                    location: location,
                    isLocationFormValid: true,
                });
            } else {
                const costs = component;
                const location = _.extend(stateLocation, {
                    washer_cost: costs.washer_cost,
                    dryer_cost: costs.dryer_cost,
                    note: costs.note,
                });
                this.setState({
                    location: location,
                    isLocationCostsFormValid: costs._valid,
                });
            }
        } else {
            if (this._isValid()) {
                const mansion_id = this.props.params.object_id;
                const locationToSave = _.extend(stateLocation, { mansion_id });
                this.props.CreateLocationCall(locationToSave, () =>
                    goToMansion(mansion_id)
                );
            } else {
                this.setState({ forceValidation: true });
            }
        }
    };

    getLocationCard = () => {
        const defaultCoords =
            this.state.mansionId &&
            this.props.mansionCoordsById[this.state.mansionId];
        return (
            <LargeCard type="card-edit" title={this.props.strings.location}>
                <LocationPositionForm
                    position={defaultCoords}
                    handleChange={this._handleWholeForm}
                />
            </LargeCard>
        );
    };

    render() {
        const location = this.state.location;
        if (location) {
            const info = {
                name: location.name,
                num_of_appartments: location.num_of_appartments,
                reservation_minutes: location.reservation_minutes,
                pickup_minutes: location.pickup_minutes,
                [FIELD_BOOKING_MINUTES]: location[FIELD_BOOKING_MINUTES],
                [FIELD_BOOKING_LOGIC]: location[FIELD_BOOKING_LOGIC],
                [FIELD_GATEWAY_SERIALNUMBER]:
                    location[FIELD_GATEWAY_SERIALNUMBER],
            };
            const costs = {
                washer_cost: location.washer_cost,
                dryer_cost: location.dryer_cost,
                note: location.note,
            };

            const { locationInfoCard, locationCostCard } = this.getCards(
                info,
                costs
            );
            return (
                <Row>
                    <LeftSide addClass="">
                        <TitleCard
                            title={[
                                this.props.strings.create1,
                                this.props.strings.create2,
                            ]}
                            left={{
                                content: (
                                    <Link
                                        to={`/objects/${this.props.params.object_id}`}
                                        className="icon icon-wew-arrow-left icon-sm"
                                    />
                                ),
                                title: this.props.strings.cancel,
                            }}
                        />
                        <OrderPostit />
                    </LeftSide>
                    <Col xs={9} sm={9} md={9} lg={9}>
                        <Row>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                {locationInfoCard}
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4}>
                                <Postit
                                    title={this.props.strings.Postit1.title}
                                >
                                    <p>{this.props.strings.Postit1.text1}</p>
                                    <p>{this.props.strings.Postit1.text2}</p>
                                </Postit>
                            </Col>
                            <Col xs={8}>{this.getLocationCard()}</Col>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                {locationCostCard}
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4}>
                                <Postit
                                    title={this.props.strings.Postit2.title}
                                >
                                    <p>{this.props.strings.Postit2.text1}</p>
                                    <p>{this.props.strings.Postit2.text2}</p>
                                </Postit>
                            </Col>
                        </Row>
                        <Row className="spacer-tb">
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <Link
                                    onClick={() => {
                                        this._handleWholeForm(null, true);
                                    }}
                                    className="btn btn-primary pull-right"
                                    data-testid="create-location-button"
                                >
                                    {this.props.strings.createLocation}
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            );
        } else {
            return <div />;
        }
    }
}

export default connectR(
    (rootState) => ({
        mansionsById: rootState.mansions.mansionsById,
        mansionCoordsById: rootState.mansions.mansionCoordsById,
    }),
    { LoadLocationsForMansionId, CreateLocationCall, LoadMansions }
)(translate('CreateLocation')(withParams(CreateLocation)));
